import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
/**
 * `<DrawerContent>` - Обёртка для контента Drawer.
 * Предоставляет стили для контента.
 */
export const DrawerContent = /*#__PURE__*/forwardRef(function DrawerContent({
  children,
  className,
  ...props
}, ref) {
  const testId = props['data-testid'] || 'drawer-content';
  const contentClassName = useMemo(() => clsx(styles.content, className), [className]);
  return /*#__PURE__*/React.createElement("div", {
    ...props,
    className: contentClassName,
    ref: ref,
    "data-testid": testId
  }, children);
});